// Ringing and ringback made with WebAudio (no sound files to ship): the incoming ring as two short
// beeps every 2 s, the ringback as 1 s on, 3 s off at 425 Hz (the European call progress tone).

export class Tone {
  private context: AudioContext | null = null;
  private timer: ReturnType<typeof setInterval> | null = null;

  ring() {
    this.start(2000, (ctx, at) => {
      this.beep(ctx, at, 880, 0.18);
      this.beep(ctx, at + 0.25, 880, 0.18);
    });
  }

  ringback() {
    this.start(4000, (ctx, at) => this.beep(ctx, at, 425, 1, 0.08));
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
    void this.context?.close().catch(() => undefined);
    this.context = null;
  }

  private start(periodMs: number, play: (ctx: AudioContext, at: number) => void) {
    this.stop();
    try {
      const ctx = new AudioContext();
      this.context = ctx;
      play(ctx, ctx.currentTime + 0.05);
      this.timer = setInterval(() => play(ctx, ctx.currentTime + 0.05), periodMs);
    } catch {
      // No audio (autoplay blocked before any click): the screen still shows the call.
    }
  }

  private beep(ctx: AudioContext, at: number, frequency: number, seconds: number, volume = 0.15) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.frequency.value = frequency;
    gain.gain.setValueAtTime(0, at);
    gain.gain.linearRampToValueAtTime(volume, at + 0.02);
    gain.gain.setValueAtTime(volume, at + seconds - 0.03);
    gain.gain.linearRampToValueAtTime(0, at + seconds);
    osc.connect(gain).connect(ctx.destination);
    osc.start(at);
    osc.stop(at + seconds);
  }
}
